// deno-lint-ignore-file ban-unused-ignore no-explicit-any no-empty-interface
///////////////////////////////////
// !!! DO NOT EDIT THIS FILE !!! //
///////////////////////////////////

import type { SlackAPIResponse } from "../response";
export type AdminUsersGetExpirationResponse = SlackAPIResponse & {
  error?: string;
  needed?: string;
  ok: boolean;
  provided?: string;
  user?: User;
};

export interface User {
  email?: string;
  expiration_ts?: number;
  id?: string;
  is_restricted?: boolean;
  is_ultra_restricted?: boolean;
}
